import { EventStatus, League } from '@/types/api.generated';

const VALID_EVENTS = [EventStatus.Scheduled, EventStatus.Delayed, EventStatus.InProgress];

export const isEventAcceptingBets = (item: { league: League; status: EventStatus }) => {
    return VALID_EVENTS.includes(item.status);
};
